<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/accountancy')">Contabilidad</li>
        <li class="breadcrumb-item active" aria-current="page">Transacciones</li>
      </ol>
    </nav>

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <vs-card>
            <template slot="header">
              <div class="flex items-center justify-between">
                <span class="text-xl font-bold">Transacciones</span>
                <vs-button class="rounded-full" icon="add" @click="editTransaction='New'"/>
              </div>
            </template>

            <div class="flex items-center justify-around mb-5">
              <div class="w-3/12">
                <span class="pt-2 pb-2 font-bold">
                   {{ `Mostrando filas ${results.from} - ${results.to} de ${results.total}` }}
                </span>
              </div>

              <vs-input
                  class="w-4/12"
                  icon="search"
                  v-model="query" @keyup.enter="getTransactions" placeholder="Buscar TRX Type"/>

              <div
                  class="con-pagination-table vs-table--pagination">
                <vs-pagination
                    v-model="current_page"
                    :total="results.last_page"
                    @change="getTransactions()"/>
              </div>
            </div>

            <vs-table :data="results.data">
              <template slot="thead">
                <vs-th>ID</vs-th>
                <vs-th>Tipo de TRX</vs-th>
                <vs-th>Concepto</vs-th>
                <vs-th>Descripción</vs-th>
                <vs-th>Tipo de cuenta</vs-th>
                <vs-th>Modificado por</vs-th>
                <vs-th>Estatus</vs-th>
                <vs-th style="text-align: center">Editar | Borrar</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr v-if="editTransaction==='New'">
                  <vs-td>{{ editTransaction }}</vs-td>
                  <vs-td>
                    <vs-input label="Tipo de TRX" v-model="trx_type"/>
                  </vs-td>
                  <vs-td>
                    <vs-textarea label="Concepto" v-model="concept"/>
                  </vs-td>
                  <vs-td>
                    <vs-textarea label="Descripción" v-model="description"/>
                  </vs-td>
                  <vs-td>
                    <vs-select label="Tipo de cuenta" v-model="accountType">
                      <vs-select-item
                          v-for="accountType in accountTypes"
                          :key="accountType.id"
                          :value="accountType.id"
                          :text="accountType.name"/>
                    </vs-select>
                  </vs-td>
                  <vs-td></vs-td>
                  <vs-td><vs-switch v-model="transactionStatus" color="success"/></vs-td>
                  <vs-td style="width: 16%;text-align: center">
                    <div class="flex gap-2">
                      <vs-button
                          icon="save"
                          class="rounded-full"
                          color="primary"
                          @click="guardarTransaction()"/>

                      <vs-button icon="clear" class="rounded-full text-black" color="light" @click="limpiar()"/>
                    </div>
                  </vs-td>
                </vs-tr>
                <vs-tr v-for="transaction in results.data" :key="transaction.id">
                  <vs-td>{{ transaction.id }}</vs-td>
                  <vs-td>
                    <vs-input class="w-24" v-if="editTransaction===transaction.id" label="Tipo de TRX"
                              v-model="trx_type"/>
                    <span v-else>{{ transaction.trx_type }}</span>
                  </vs-td>
                  <vs-td class="w-3/12">
                    <vs-textarea v-if="editTransaction===transaction.id" label="Concepto" v-model="concept"/>
                    <span v-else>{{ transaction.concept }}</span>
                  </vs-td>
                  <vs-td class="w-3/12">
                    <vs-textarea v-if="editTransaction===transaction.id" label="Descripción" v-model="description"/>
                    <span v-else>{{ transaction.description }}</span>
                  </vs-td>
                  <vs-td class="w-1/12">
                    <vs-select
                        v-if="editTransaction===transaction.id" label="Tipo de cuenta"
                        v-model="accountType">
                      <vs-select-item
                          v-for="accountType in accountTypes"
                          :key="accountType.id"
                          :value="accountType.id"
                          :text="accountType.name"/>
                    </vs-select>
                    <div v-else>
                      <span class="label" :class="{
                        'label-primary': transaction.accounting_type === 0,
                        'label-warning': transaction.accounting_type === 1,
                      }">
                        {{ translateAccountType(transaction.accounting_type) }}
                      </span>
                    </div>
                  </vs-td>
                  <vs-td>
                    {{ printUser(transaction) }}
                  </vs-td>
                  <vs-td>
                    <div v-if="editTransaction===transaction.id">
                      <vs-switch v-model="transactionStatus" color="success"/>
                    </div>
                    <span v-else class="label" :class="{
                        'label-warning': transaction.status === 0,
                        'label-success': transaction.status === 1,
                      }">
                      {{transaction.status === 1 ? 'Activo': 'Inactivo'}}
                    </span>
                  </vs-td>
                  <vs-td style="width: 20%;text-align: center">
                    <div class="flex gap-2" v-if="editTransaction===transaction.id">
                      <vs-button
                          icon="save"
                          color="primary"
                          class="rounded-full"
                          @click="guardarTransaction()"/>

                      <vs-button icon="clear" color="light" class="rounded-full text-black" v-on:click="limpiar()"/>
                    </div>
                    <div v-else class="flex gap-2">
                      <vs-button
                          icon="edit"
                          color="light"
                          class="rounded-full text-black"
                          @click="editarTransaction(transaction)"/>

                      <vs-button
                          icon="delete"
                          color="danger"
                          class="rounded-full"
                          @click="borrarTransaction(transaction.id)"/>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>

            <div
                class="flex items-center justify-center con-pagination-table vs-table--pagination">
              <vs-pagination
                  v-model="current_page"
                  :total="results.last_page"
                  @change="getTransactions()"/>
            </div>
          </vs-card>
        </div>
      </div>
    </div>
  </div>

</template>

<script lang="js">
export default {
  name: 'src-views-admin-accounting-transactions',
  props: [],
  mounted() {
    this.getTransactions();
  },
  data() {
    return {
      editTransaction: null,
      trx_type: null,
      concept: null,
      description: null,
      results: {},
      current_page: 1,
      per_page: 20,
      accountType: null,
      accountTypes: [{id: 0, name: 'No transacional'}, {id: 1, name: 'Transacional'},],
      query: "",
      transactionStatus: false
    }
  },
  methods: {
    translateAccountType(accountType) {
      const accountTypesFiltered = this.accountTypes.filter(at => at.id === accountType);
      if (accountTypesFiltered.length > 0) {
        return accountTypesFiltered[0].name;
      }

      return 'N/A';
    },
    printUser(transaction) {
      return transaction.user ? transaction.user.alias : 'N/A';
    },
    limpiar() {
      this.editTransaction = null;
      this.trx_type = null;
      this.concept = null;
      this.description = null;
      this.accountType = null;
      this.transactionStatus = false;
    },
    async getTransactions() {
      this.$vs.loading();
      const {data} = await axios.get(`/api/accounting/transactions?page=${this.current_page}&per_page=${this.per_page}&query=${this.query}`);
      this.results = data;
      this.$vs.loading.close();
    },
    guardarTransaction() {
      Vue.toasted.show('Guardando Transacción...', {position: 'bottom-center', closeOnSwipe: false});
      axios.post('/api/accounting/transactions/save', {
        'transaction_id': this.editTransaction === 'New' ? -1 : this.editTransaction,
        'trx_type': this.trx_type,
        'concept': this.concept,
        'accounting_type': this.accountType,
        'status': this.transactionStatus ? 1 : 0,
        'description': this.description,
      }).then(response => {
        this.limpiar();
        this.getTransactions();
        Vue.toasted.clear();
        Vue.toasted.show('¡¡ Transacción guardada correctamente !!', {
          position: 'bottom-center',
          type: 'success',
          closeOnSwipe: false,
          duration: 10000
        });
      }).catch(error => {
        Vue.toasted.clear();
        Vue.toasted.show('Ha ocurrido un error', {
          position: 'bottom-center',
          type: 'error',
          closeOnSwipe: true,
          duration: 10000
        });
      });

    },
    editarTransaction(transaction) {
      this.editTransaction = transaction.id;
      this.trx_type = transaction.trx_type;
      this.concept = transaction.concept;
      this.description = transaction.description;
      this.accountType = transaction.accounting_type;
      this.transactionStatus = transaction.status === 1;
    },
    borrarTransaction(tid) {
      Vue.toasted.show('Borrando Transacción...', {position: 'bottom-center', closeOnSwipe: false});
      axios.post('/api/accounting/transactions/delete', {
        'transaction_id': tid,
      }).then(response => {
        this.getTransactions();
        Vue.toasted.clear();
        Vue.toasted.show('¡¡ Transacción borrada correctamente !!', {
          position: 'bottom-center',
          type: 'success',
          closeOnSwipe: false,
          duration: 10000
        });
      }).catch(error => {
        Vue.toasted.clear();
        Vue.toasted.show('Ha ocurrido un error', {
          position: 'bottom-center',
          type: 'error',
          closeOnSwipe: true,
          duration: 10000
        });
      });
    }
  }
}
</script>
